import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {BrowserAnimationsModule, NoopAnimationsModule} from "@angular/platform-browser/animations";
import {CommonModule} from "@angular/common";
import {BrowserModule} from "@angular/platform-browser";

/**
 * @title Basic select
 */
@Component({
  selector: ' app-st-select-short',
  templateUrl: 'st-select-short.component.html',
  styleUrls: ['st-select-short.component.scss'],
  standalone: false
})
export class StSelectShortComponent {

  @Input()
  defaultOption = 'Select';

  @Input()
  idVal: string = ''

  @Input()
  label: string = '';

  @Input()
  idKey: string = '';

  @Input()
  displayKey: string = '';

  @Input()
  valueKey: string = '';

  @Input()
  inputArray: any[] = [];

  @Output()
  onClick = new EventEmitter<string>();

  @Output()
  onchange = new EventEmitter<string>();

  constructor() {

  }
}
